import { Plane } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

export const RemotePickupBadge = () => {
  const { t } = useTranslation("shared");
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="flex h-6 w-6 items-center justify-center rounded-full bg-gray-900">
          <Plane width={14} height={14} color="white" />
        </span>
      </TooltipTrigger>
      <TooltipContent>
        <p>{t("remotePickupBadge.tooltip")}</p>
      </TooltipContent>
    </Tooltip>
  );
};
